import * as React from 'react';
import { FormField } from '@cian/ui-kit';
import { TimeInput } from '../../TimeInput';
export var TimeField = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      onChange = _ref.onChange,
      value = _ref.value;
  return /*#__PURE__*/React.createElement(FormField, {
    label: label,
    withoutMargin: true
  }, /*#__PURE__*/React.createElement(TimeInput, {
    inputRef: ref,
    onChange: onChange,
    value: value,
    disabled: disabled,
    invalid: !!error
  }));
});
TimeField.displayName = 'TimeField';